module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_7_1.171a7460.png";